export enum FormKey {
  ADDRESS_ID = 'externalAVSAddressId',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  CITY = 'city',
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  ITEM_CATEGORY = 'itemCategory',
  LAST_NAME = 'lastName',
  MERCHANDISE_ADDRESS_ID = 'merchandiseLocationExternalAVSAddressId',
  MERCHANDISE_ADDRESS_LINE_1 = 'merchandiseLocationLine1',
  MERCHANDISE_ADDRESS_LINE_2 = 'merchandiseLocationLine2',
  MERCHANDISE_CITY = 'merchandiseLocationCity',
  MERCHANDISE_POSTAL_CODE = 'merchandiseLocationPostalCode',
  MERCHANDISE_STATE_CODE = 'merchandiseLocationRegionOrStateCode',
  MERCHANDISE_IS_FORMATTED = 'merchandiseLocationIsFormatted',
  ADDRESS_IS_FORMATTED = 'isFormatted',
  MODEL_NUMBER = 'modelNumber',
  PHONE_DIALLING_CODE = 'phoneDiallingCode',
  PHONE_NUMBER = 'phoneNumber',
  POSTAL_CODE = 'postalCode',
  ARRIVAL_DATE = 'purchaseDate',
  PURCHASE_PRICE = 'purchasePrice',
  SERIAL_NUMBER = 'serialNumber',
  STATE_CODE = 'regionOrStateCode',
  SUPER_CATEGORY = 'superCategory',
  COUNTRY_CODE = 'countryCode',
}
